import React from 'react';
import { CountAndTotal } from '.';

interface DealBuilderContextType {
  setModalDismissFocusTargetId: (id: string | null) => void;
  setProductCountAndTotal?: React.Dispatch<React.SetStateAction<CountAndTotal | null>>;
  setSelectedGroup: React.Dispatch<React.SetStateAction<string | null>>;
  dismissProductsScreen: () => void;
}

const defaultDealBuilderContext: DealBuilderContextType = {
  setModalDismissFocusTargetId: () => {},
  setProductCountAndTotal: () => {},
  setSelectedGroup: () => {},
  dismissProductsScreen: () => {},
};

export const DealBuilderContext =
  React.createContext<DealBuilderContextType>(defaultDealBuilderContext);
